import { Box, IconButton, InputAdornment, TextField } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import Check from "mdi-material-ui/Check";
import Close from "mdi-material-ui/Close";
import Download from "mdi-material-ui/Download";
import Plus from "mdi-material-ui/Plus";
import moment from "moment";
import Papa from "papaparse";
import React, { Component } from "react";
import { clearSearch, handleSearchChange } from "../../classes/Helper";
import { tableSortStyles, bindTableSortHandlers } from "../../classes/tableSort";
import DataTable from "../../components/DataTable";
import TableCellLink from "../../components/TableCellLink";
import TitleBar from "../../components/TitleBar";
import TitleBarButton from "../../components/TitleBarButton";
import TitleBarTitle from "../../components/TitleBarTitle";
import OrganizationStore from "../../stores/OrganizationStore";
import SessionStore from "../../stores/SessionStore";

let FileDownload = require('downloadjs');

const styles = {
  ...tableSortStyles,
  grid: {
    display:'flex',
    alignItems:'center',
    flexWrap:'wrap',
  },
  boxDefault: {
    width: '270px',
  },
};

class ListOrganizations extends Component {
  constructor() {
    super()
    this.getPage = this.getPage.bind(this)
    this.getRow = this.getRow.bind(this)
    bindTableSortHandlers(this)
    this.handleSearchChange = handleSearchChange.bind(this)
    this.clearSearch = clearSearch.bind(this)
    this.exportOrganizationsCSV = this.exportOrganizationsCSV.bind(this)

    this.state = {
      orderBy: null,
      order: null,
      search: null,
      isExportingCSV: false,
    }
    this.TableRef = React.createRef()
  }

  getPage(limit, offset, callbackFunc) {
    if (this.timeOut) {
      clearTimeout(this.timeOut)
    }
    this.timeOut = setTimeout(() => {
      OrganizationStore.list(
        this.state.search,
        limit,
        offset,
        (obj) => {
          callbackFunc(obj)
        },
        this.state.orderBy,
        this.state.order,
      )
    }, 400)
  }

  exportOrganizationsCSV() {
    this.setState({ isExportingCSV: true })

    OrganizationStore.list(
      this.state.search,
      9999,
      0,
      (resp) => {
        if (!resp.result || resp.result.length === 0) {
          this.setState({ isExportingCSV: false })
          return
        }

        const formatDateTime = (value) => (value ? moment(value).format("DD.MM.YYYY HH:mm:ss") : "")

        const rows = resp.result.map((obj) => ({
          ID: obj.id,
          Name: obj.name,
          "Display name": obj.displayName,
          Devices: obj.deviceCount,
          Gateways: obj.gatewayCount,
          "Can have gateways": obj.canHaveGateways ? "Yes" : "No",
          "Created at": formatDateTime(obj.createdAt),
          "Updated at": formatDateTime(obj.updatedAt),
        }))

        const csv = "\uFEFF" + Papa.unparse(rows)
        const fileName = `Organizations_${moment().format("DD-MM-YY--h-mm-ss")}.csv`
        FileDownload(csv, fileName, "text/csv;charset=utf-8")

        this.setState({ isExportingCSV: false })
      },
      this.state.orderBy,
      this.state.order,
    )
  }

  getRow(obj) {
    let createdAt = ""
    if (obj.createdAt) {
      createdAt = moment(obj.createdAt).format("DD.MM.YYYY")
    }

    let icon = null

    if (obj.canHaveGateways) {
      icon = <Check />
    } else {
      icon = <Close />
    }

    return (
      <TableRow key={obj.id} hover>
        <TableCell>{obj.id}</TableCell>
        <TableCellLink to={`/organizations/${obj.id}`}>{obj.name}</TableCellLink>
        <TableCell>{obj.displayName}</TableCell>
        <TableCell>{obj.deviceCount}</TableCell>
        <TableCell>{obj.gatewayCount}</TableCell>
        <TableCell>{icon}</TableCell>
        <TableCell>{createdAt}</TableCell>
      </TableRow>
    )
  }

  render() {
    let titleParams = SessionStore.isAdmin()
      ? {
          buttons: [
            <TitleBarButton key="export" label="Export CSV" icon={<Download />} onClick={this.exportOrganizationsCSV} disabled={this.state.isExportingCSV} />,
            <TitleBarButton key="create" label="Create" icon={<Plus />} to={`/organizations/create`} />,
          ],
        }
      : {}

    return (
      <Grid container spacing={4}>
        <TitleBar {...titleParams}>
          <TitleBarTitle title="Organizations" />
        </TitleBar>

        <Grid item xs={12} style={styles.grid}>
          <Box component="div" mr={2}>
            <TextField
              className={this.props.classes.boxDefault}
              label={"Search"}
              id="Search"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.handleSearchChange}
              value={this.state.search || ""}
              InputProps={{
                endAdornment: this.state.search && (
                  <InputAdornment position="end">
                    <IconButton onClick={this.clearSearch} style={{ padding: "0" }} color="default" component="span">
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              size="small"
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <DataTable
            orderBy={this.state.orderBy}
            order={this.state.order}
            ref={this.TableRef}
            header={
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell {...this.makeCellSortProps("name")}>{this.makeSortLabel("name", "Name")}</TableCell>
                <TableCell {...this.makeCellSortProps("displayName")}>{this.makeSortLabel("displayName", "Display name")}</TableCell>
                <TableCell {...this.makeCellSortProps("dev_count")}>{this.makeSortLabel("dev_count", "Devices")}</TableCell>
                <TableCell {...this.makeCellSortProps("gw_count")}>{this.makeSortLabel("gw_count", "Gateways")}</TableCell>
                <TableCell {...this.makeCellSortProps("canHaveGateways")}>{this.makeSortLabel("canHaveGateways", "Can have gateways")}</TableCell>
                <TableCell {...this.makeCellSortProps("createdAt")}>{this.makeSortLabel("createdAt", "Created at")}</TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(ListOrganizations);
